export default "__VITE_ASSET__DxuTmFwf__"